import React from "react"
import { TouchableOpacity } from "react-native"
import { Text, Icon, IconName } from '@components'
import { useTheme } from "@react-navigation/native"
import getStyle from "./style"

const ActionItem = ({action, isLast = false }:{action: {icon: string, label: string, onPress: () => void}, isLast?: boolean}) => {
  const theme = useTheme()
  const styles = getStyle(theme)
    return (
        <TouchableOpacity
            style={[
                styles.actionItem,
                isLast && styles.actionItemBorder
            ]}
            onPress={action.onPress}
        >
            <Icon 
                name={action.icon as IconName} 
                size={20} 
                color={theme.colors.secondary} 
            />
            <Text 
                type="body" 
                style={styles.actionLabel}
            >
                {action.label}
            </Text>
        </TouchableOpacity>
    )
}

export default ActionItem